import { NewsCardLoader } from 'hb-react/frontoffice/apps/NewsIndex/components/NewsCardLoader';
import { SORT_BY } from 'hb-react/frontoffice/apps/NewsIndex/constants';
import {
  makeFetchItems,
  makeItemRenderer,
} from 'hb-react/frontoffice/apps/NewsIndex/utils';
import { ITEMS_QUERY_KEYS } from 'hb-react/frontoffice/components/BlocksRenderer/blocks/Items/utils/queryUtils';
import { BLOCKS } from 'hb-react/frontoffice/components/BlocksRenderer/shared';
import oneColumnTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/OneColumnTemplate';
import twoColumnsTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/TwoColumnsTemplate';

import type { NewsSearchResultsArgs } from './types';

export const newsSearchResults = ({
  breakpoint = 'm',
  config,
}: NewsSearchResultsArgs) => {
  const ITEMS_BY_ROW = {
    s: 1,
    m: 2,
    l: 2,
    xl: 3,
  };

  const fetchItems = makeFetchItems(config.routes.news_url, {
    pinned_on_index_page: false, // flagEvNewsRevamp === false
    pinned_to_index_page: false, // flagEvNewsRevamp === true
  });

  const itemRenderer = makeItemRenderer({ pinned: false });

  return {
    attributes: {
      fetchItems,
      initialSort: SORT_BY[0],
      itemLoader: NewsCardLoader,
      itemRenderer,
      sortBy: SORT_BY,
    },
    component: BLOCKS.items.component,
    id: ITEMS_QUERY_KEYS.news.items,
    templateAttributes: {
      [oneColumnTemplate.id]: {
        itemsByRow: ITEMS_BY_ROW[breakpoint],
      },
      [twoColumnsTemplate.id]: {
        itemsByRow: 2,
      },
    },
  };
};
